import {
  FormControl,
  FormBuilder,
  Validators,
  FormGroup,
  FormArray
} from '@angular/forms';
import * as _ from 'underscore';
import {
  RegulationActionDetail,
  RegulationModel,
  LinkedRule,
  TableSortModel,
  LinkedPolicy,
  RegulationFilterModel,
  FilterViewModel,
  MasterRegulationActionFilter,
  RegulationActionFilterModel
} from 'src/app/core/models/regulation';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { UserProfile } from 'src/app/core/models/user';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { TooltipDirective } from 'ngx-bootstrap/tooltip';
import { MasterHelper, Logger } from 'src/app/core/utilities';
import { RegulationService } from 'src/app/core/services/regulation';
import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { RegulationFilterViewModel } from 'src/app/core/models/regulation/regulation.model';
import { GlobalService } from 'src/app/core/services/global/global.service';


@Component({
  selector: 'app-action-detail',
  templateUrl: './action-detail.component.html',
  styleUrls: ['./action-detail.component.scss']
})
export class ActionDetailComponent implements OnInit {

  @ViewChildren(TooltipDirective)
  tooltips!: QueryList<TooltipDirective>;

  regulationId = 0;
  isLoadingRegDetail = false;
  user: UserProfile;
  masterFilters: MasterRegulationActionFilter;
  regulationFilter: RegulationActionFilterModel;
  regulationActionDetail: RegulationActionDetail;
  regulation: RegulationModel;
  isLoadingFilters = false;
  linkedRules: Array<LinkedRule>;
  linkedRulesSorting: TableSortModel;
  linkedPolicies: LinkedPolicy[];
  linkedPoliciesSorting: TableSortModel;
  ruleTopicsForToolTip = '';

  // tslint:disable-next-line:max-line-length
  keywords = ['Accounting', 'Audit', 'Banking Reform', 'Basel I', 'Basel II', 'Basel III', 'Capital', 'Colleges of supervisors', 'Compensation', 'Consumer Protection and Financial Innovation', 'Financial Innovation', 'Corporate Governance', 'Credit risk', 'Deposit Insurance', 'Financial Benchmarks', 'Financial Conglomerates', 'FinTech', 'Implementation monitoring', 'Interest Rate Risk', 'Internal Models', 'Investment Firms', 'Large Exposures and structural measures', 'Leverage Ratio', 'Liquidity', 'Liquidity Risk', 'Macroprudential', 'Market Infrastructures', 'Market Risk', 'Anti Money Laundering', 'Terrorist financing', 'Operational Risk', 'OTC Derivatives', 'Passporting Supervision of Branches', 'Supervision of Branches', 'Payment Services and Electronic Money', 'Electronic Money', 'Recovery', 'Resolution', 'Crisis Management', 'Renumeration', 'Reporting', 'Risk Analysis and Data', 'Risk Management', 'Securitisation', 'Shadow Banking', 'Stress Testing', 'Supervision', 'Supervisory Reviews', 'Systemically Important Financial Institutions', 'Transparency', 'Disclosure', 'Insurance', 'Information Technology and Cyber Security', 'Pillar 1', 'Pillar 2', 'Pillar 3', 'Governance', 'Climate', 'Compensation', 'Credit Rating Agencies', 'Cyber Security', 'Effects of Reform', 'Benchmarks', 'Impact Assessment', 'Legal Entity Identifer', 'Peer Review', 'Fund Management', 'MiFiD', 'IFRS', 'Post Trading', 'Corporate Information', 'Short Selling', 'Market Abuse', 'Market Integrity', 'Prospectus', 'Warnings', 'Trade Repository', 'Securities Financing Transactions', 'Transparency and Disclosure'];
  searchedKeywords = this.keywords;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;

  isSubmitting = false;
  response: any;
  isError = false;

  searchedRegulators: FilterViewModel[] = [];
  searchedStatus: FilterViewModel[] = [];
  searchedActionTypes: FilterViewModel[] = [];
  searchedTopics: FilterViewModel[] = [];
  searchedImpactAreas: FilterViewModel[] = [];
  searchedImpacts: FilterViewModel[] = [];
  searchedAssessments: FilterViewModel[] = [];

  separatorKeysCodes: number[] = [ENTER, COMMA];

  actionManagerForm: any;

  constructor(
    private regulationService: RegulationService,
    private sessionService: SessionService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private _globalService: GlobalService) {
    this.regulationFilter = new RegulationActionFilterModel();
    this.masterFilters = new MasterRegulationActionFilter();
    this.regulationActionDetail = new RegulationActionDetail();
    this.regulation = new RegulationModel();
    this.linkedRules = new Array<LinkedRule>();
    this.linkedRulesSorting = new TableSortModel();
    this.linkedPolicies = new Array<LinkedPolicy>();
    this.linkedPoliciesSorting = new TableSortModel();
    this.user = new UserProfile();
  }

  async ngOnInit() {
    this.getMasterFilters();
    this.createActionManagerForm();
    this.user = await this._globalService.getLoginUserData();
    this.route.params.subscribe((params: any) => {
      if (!isNaN(Number(params['id']))) {
        this.regulationId = Number(params['id']);
      } else {
        this.router.navigate(['/']);
      }
      this.getActionDetail();
    });
  }

  // async getUserProfile() {
  //   this.sessionService.getLoginUserInfo().subscribe((user: UserProfile) => {
  //     this.user = user;
  //   });
  // }

  createActionManagerForm(): void {
    this.actionManagerForm = this.fb.group({
      type: new FormControl('', Validators.required),
      topic: new FormControl('', Validators.required),
      impactArea: new FormControl('', Validators.required),
      actionDate: new FormControl('', Validators.required),
      effectiveDate: new FormControl('', Validators.required),
      status: new FormControl('', Validators.required),
      impact: new FormControl('', Validators.required),
      assessment: new FormControl('', Validators.required),
    });
  }

  async getMasterFilters(): Promise<void> {
    this.isLoadingFilters = true;
    this.regulationService.getMasterRegulationActionFilters().subscribe((data: MasterRegulationActionFilter) => {
        this.masterFilters = data;
        this.searchedStatus = this.masterFilters.status;
        this.searchedActionTypes = this.masterFilters.types;
        this.searchedImpactAreas = this.masterFilters.impactAreas;
        this.searchedImpacts = this.masterFilters.impacts;
        this.searchedAssessments = this.masterFilters.assessments;
        this.searchedTopics = this.masterFilters.topics;
        this.isLoadingFilters = false;

        this.actionManagerForm.controls['topic'].valueChanges.subscribe((term: any) => {
          this.searchedTopics = term ? this.filterRuleTopics(term) : this.masterFilters.topics;
        });

        this.actionManagerForm.controls['status'].valueChanges.subscribe((term: any) => {
          this.searchedStatus = term ? this.filterStatus(term) : this.masterFilters.status;
        });

        this.actionManagerForm.controls['type'].valueChanges.subscribe((term: any) => {
          this.searchedActionTypes = term ? this.filterActionTypes(term) : this.masterFilters.types;
        });

        this.actionManagerForm.controls['impactArea'].valueChanges.subscribe((term: any) => {
          this.searchedImpactAreas = term ? this.filterImpactAreas(term) : this.masterFilters.impactAreas;
        });

        this.actionManagerForm.controls['impact'].valueChanges.subscribe((term: any) => {
          this.searchedImpacts = term ? this.filterImpacts(term) : this.masterFilters.impacts;
        });

        this.actionManagerForm.controls['assessment'].valueChanges.subscribe((term: any) => {
          this.searchedAssessments = term ? this.filterAssessments(term) : this.masterFilters.assessments;
        });

      }, (error: HttpErrorResponse) => {
        this.isLoadingFilters = false;
        Logger.log(this.constructor.name, error.error);
      });
  }


  async getActionDetail(): Promise<void> {
    this.isLoadingRegDetail = true;
    this.regulationService.getActionDetail(this.regulationId)
      .subscribe((data: RegulationActionDetail) => {
        this.isLoadingRegDetail = false;
        if (data) {
          // data.ActionDate = MasterHelper.formatDate(data.ActionDate, 'DD-MMM-YYYY').toString();
          // data.EffectiveDate = MasterHelper.formatDate(data.EffectiveDate, 'DD-MMM-YYYY').toString();
          data.userId = this.user.userId;
          this.regulationActionDetail = data;
          this.regulationActionDetail.date = MasterHelper.formatDate(this.regulationActionDetail.date, 'DD-MMM-YYYY').toString();

          // tslint:disable-next-line:max-line-length
          this.setActionFormValue(data.type, data.topic, data.impactArea, data.status, data.actionDate, data.effectiveDate, data.impact, data.assessment);
        }
        const filter = new RegulationFilterModel();
        filter.Id = this.regulationId;
        this.getRegulation(filter);
      }, (error: HttpErrorResponse) => {
        this.isLoadingRegDetail = false;
        Logger.log(this.constructor.name, error.error);
      });
  }

  setActionFormValue(
    type: string, topic: string, impactArea: string, status: string, actionDate: string, effectiveDate: string,
    impact: string, assessment: string): void {
    this.actionManagerForm.controls['type'].setValue(type);
    this.actionManagerForm.controls['topic'].setValue(topic);
    this.actionManagerForm.controls['impactArea'].setValue(impactArea);
    this.actionManagerForm.controls['status'].setValue(status);
    this.actionManagerForm.controls['actionDate'].setValue(actionDate);
    this.actionManagerForm.controls['effectiveDate'].setValue(effectiveDate);
    this.actionManagerForm.controls['impact'].setValue(impact);
    this.actionManagerForm.controls['assessment'].setValue(assessment);
  }

  async getRegulation(regulationFilter: RegulationFilterModel | null): Promise<void> {
    let regulationId = 0;
    if (regulationFilter) {
      regulationFilter.UserId = this.user.userId;
      regulationId = regulationFilter.Id as number;
    }
    this.isLoadingRegDetail = true;
    this.regulationService.getRegulation(0, regulationId)
      .subscribe((data: RegulationModel) => {
        if (data) {
          this.regulation = data;
          this.regulation.date = MasterHelper.formatDate(this.regulation.date, 'DD-MMM-YYYY').toString();
          // tslint:disable-next-line:max-line-length
          this.ruleTopicsForToolTip = this.regulation.ruleTopic ? this.regulation.ruleTopic.length > 0 ? this.regulation.ruleTopic.toString().split(',').join('<br/>') : '' : '';
          // tslint:disable-next-line:max-line-length
          const linkedRuleSplit: string[] = this.regulation.linkedRules ? this.regulation.linkedRules.length > 0 ? this.regulation.linkedRules.toString().split('||') : [] : [];

          for (const rule of linkedRuleSplit) {
            const linkedRulePropSplit = rule.split('|');
            const linkedRule = new LinkedRule();
            linkedRule.Country = linkedRulePropSplit[0].trim();
            linkedRule.Regulator = linkedRulePropSplit[1].trim();
            linkedRule.Title = linkedRulePropSplit[2].trim();
            this.linkedRules.push(linkedRule);
          }
          this.sortLinkedRules('Country');

          const policies = this.regulation.linkedPolicies ? this.regulation.linkedPolicies.split('|') : '';
          for (const lPolicy of policies) {
            // tslint:disable-next-line:max-line-length
            const policy = new LinkedPolicy(1234, lPolicy.trim(), 'Policy', 'xSmith', 'Asset Management Wealth Management', 'COO', 'UK Germany France');
            this.linkedPolicies.push(policy);
          }

          const risks = this.regulation.linkedRisks ? this.regulation.linkedRisks.split('|') : '';
          for (const lRisk of risks) {
            // tslint:disable-next-line:max-line-length
            const risk = new LinkedPolicy(1234, lRisk.trim(), 'Risk', 'xSmith', 'Asset Management Wealth Management', 'COO', 'UK Germany France');
            this.linkedPolicies.push(risk);
          }

          const processes = this.regulation.linkedProcesses ? this.regulation.linkedProcesses.split('|') : '';
          for (const lProcess of processes) {
            // tslint:disable-next-line:max-line-length
            const process = new LinkedPolicy(1234, lProcess.trim(), 'Process', 'xSmith', 'Asset Management Wealth Management', 'COO', 'UK Germany France');
            this.linkedPolicies.push(process);
          }
          this.sortLinkedPolicies('Name');
        }
        this.isLoadingRegDetail = false;
      }, (error: HttpErrorResponse) => {
        this.isLoadingRegDetail = false;
        Logger.log(this.constructor.name, error.error);
      });
  }

  onSubmit(): void {
    if (this.actionManagerForm.invalid) {
      this.markAsTouched(this.actionManagerForm);
      return;
    }
    this.isSubmitting = true;
    const formValue = this.actionManagerForm.value;
    this.regulationActionDetail.userId = this.user.userId;
    if (this.regulationActionDetail.id === 0) {
      this.regulationActionDetail.uniqueId = this.regulation.id;
      this.regulationActionDetail.country = this.regulation.country;
      this.regulationActionDetail.title = this.regulation.title[0];
      this.regulationActionDetail.geography = this.regulation.geography;
      this.regulationActionDetail.mappingID = this.regulation.mappingID;
      this.regulationActionDetail.regulator = this.regulation.regulator;
      this.regulationActionDetail.date = MasterHelper.formatDate(this.regulation.date, 'YYYY-MM-DD');
    }
    this.regulationActionDetail.title = this.regulation.title[0];
    this.regulationActionDetail.actionDate = MasterHelper.formatDate(formValue.actionDate, 'YYYY-MM-DD');
    this.regulationActionDetail.effectiveDate = MasterHelper.formatDate(formValue.effectiveDate, 'YYYY-MM-DD');
    this.regulationActionDetail.assessment = formValue.assessment;
    this.regulationActionDetail.status = formValue.status;
    this.regulationActionDetail.topic = formValue.topic;
    this.regulationActionDetail.type = formValue.type;
    this.regulationActionDetail.impact = formValue.impact;
    this.regulationActionDetail.impactArea = formValue.impactArea;

    this.regulationService.saveRegulationActionDetail(this.regulationActionDetail)
      .subscribe((value: any) => {
        this.isError = false;
        this.response = 'Saved successfully!';
        this.regulationActionDetail = value;
        this.isSubmitting = false;
        setTimeout(() => {
          this.response = '';
        }, 3000);
      }, (error: HttpErrorResponse) => {
        this.isError = true;
        this.response = 'Something went wrong, please try again.';
        setTimeout(() => {
          this.response = '';
        }, 3000);
        this.isSubmitting = false;
        Logger.log(this.constructor.name, error.error);
      });
  }

  markAsTouched(group: FormGroup | FormArray): void {
    group.markAsTouched({ onlySelf: true });

    Object.keys(group.controls).map((field) => {
      const control = group.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.markAsTouched(control);
      }
    });
  }

  sortLinkedRules(key: string): void {
    this.linkedRulesSorting.SortKey = key;
    this.linkedRules = this.linkedRulesSorting.IsDesc ? _.sortBy(this.linkedRules, key).reverse() : _.sortBy(this.linkedRules, key);
    this.linkedRulesSorting.IsDesc = !this.linkedRulesSorting.IsDesc;
  }

  sortLinkedPolicies(key: string): void {
    this.linkedPoliciesSorting.SortKey = key;
    // tslint:disable-next-line:max-line-length
    this.linkedPolicies = this.linkedPoliciesSorting.IsDesc ? _.sortBy(this.linkedPolicies, key).reverse() : _.sortBy(this.linkedPolicies, key);
    this.linkedPoliciesSorting.IsDesc = !this.linkedPoliciesSorting.IsDesc;
  }

  Close(): void {
    this.tooltips.forEach((tooltip: TooltipDirective) => {
      tooltip.hide();
    });
  }

  filterValues(search: string): any {
    return this.searchedKeywords.filter(value => value.toLowerCase().includes(search.toLowerCase()));
  }

  filterRuleTopics(search: string): any {
    return this.searchedTopics.filter(option => option.name.toLowerCase().includes(search.toLowerCase()));
  }

  filterStatus(search: string): any {
    return this.searchedStatus.filter(option => option.name.toLowerCase().includes(search.toLowerCase()));
  }

  filterActionTypes(search: string): any {
    return this.searchedActionTypes.filter(option => option.name.toLowerCase().includes(search.toLowerCase()));
  }

  filterImpactAreas(search: string): any {
    return this.searchedImpactAreas.filter(option => option.name.toLowerCase().includes(search.toLowerCase()));
  }

  filterImpacts(search: string): any {
    return this.searchedImpacts.filter(option => option.name.toLowerCase().includes(search.toLowerCase()));
  }

  filterAssessments(search: string): any {
    return this.searchedAssessments.filter(option => option.name.toLowerCase().includes(search.toLowerCase()));
  }



  routeToChangeViewer(linkedRule: string[]): any {
    let regulationFilter = new RegulationFilterModel();
    regulationFilter = this.initFilters();
    regulationFilter.Filters = regulationFilter.Filters as RegulationFilterViewModel;
    regulationFilter.Filters.LinkedRules = linkedRule;
    this.saveOnBrowser('regulationFilter', JSON.stringify(regulationFilter));

    setTimeout(() => {
      this.router.navigate(['/change-viewer']);
    }, 100);
  }

  initFilters(): any {
    const regulationFilter = new RegulationFilterModel();
    regulationFilter.Filters = new RegulationFilterViewModel();
    regulationFilter.FromDate = MasterHelper.getDateStr(30);
    regulationFilter.ToDate = MasterHelper.getDateStr(0);
    regulationFilter.SortKey = 'Date';
    regulationFilter.SkipCount = 0;
    regulationFilter.Regulator = [];
    regulationFilter.MappingID = [];
    regulationFilter.Status = [];
    regulationFilter.IsAdvance = true;

    return regulationFilter;
  }

  saveOnBrowser(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

}
